import { useJobQuoteContext } from 'components/JobQuote/context';

import JobQuoteBreakdown from '../JobQuoteBreakdown';
import JobQuoteHeader from '../JobQuoteHeader';
import JobQuotePrices from '../JobQuotePrices';

const JobQuoteFull: React.FunctionComponent = function () {
  const { footer } = useJobQuoteContext();
  return (
    <div className="flex flex-col bg-neutral-000 rounded-xl shadow-lg overflow-hidden">
      <JobQuoteHeader />
      <JobQuoteBreakdown />
      <JobQuotePrices />
      {footer}
    </div>
  );
};

export default JobQuoteFull;
